<template>

  <b-col sm="12" :lg="size" :offset="offset">
    <b-card class="backClass">

      <!-- Header -->
      <div slot="header">
        <h5 style="display: inline;" class="card-title mb-0"> {{ title }}
          <small v-if="withDate" style="font-weight:600; color:#20a8d8"> (YTD) </small>
        </h5>
        <div class="card-header-actions">
          <b-button
            variant="transparent p-1"
            attr="pdf"
            @click="downloadPDF()" >
            <i class="fa fa-file-pdf-o" style="color: rgb(32, 168, 216);" aria-hidden="true"></i>
          </b-button>
          <b-button
            @click="toggleFullScreen"
            variant="transparent p-1">
            <i style="color: #20a8d8;" class="icon-frame"></i>
          </b-button>
        </div>
      </div>
      <!-- Header END -->

      <!-- Financial Switch -->
      <div style="width: 100%; display: flex; justify-content: flex-end;" v-if="withFinancial">
          <h5>Quantity</h5>
          <c-switch
            class="mx-1"
            color="primary"
            v-model="valueQuantity"
            value="true"
            uncheckedValue="false"
            variant="pill" />
          <h5>Financials</h5>
      </div>
      <!-- Financial Switch END -->

      <div class="chart-wrapper">

        <!-- Loading -->
        <div style="height: 400px; padding-top: 150px" v-if="loadingData" class="loading">
          <b-row>
            <b-col lg="12">
              <div class="sk-double-bounce">
                <div class="sk-child sk-double-bounce1"></div>
                <div class="sk-child sk-double-bounce2"></div>
              </div>
            </b-col>
          </b-row>
        </div>
        <!-- Loading END -->

        <!-- Chart -->
        <highcharts
          ref="backRef"
          v-else
          :options="chartOptions"
          class="chart"
          :constructor-type="'chart'" />
        <!-- Chart END -->

      </div>

    </b-card>
  </b-col>

</template>

<script>
import { Chart } from "highcharts-vue";
import Highcharts from "highcharts";
import exporting from "highcharts/modules/exporting";
import { chartFunctionsMixin } from "./addons/chartFunctionsMixin.js";
import { chartOptionsStackedMixin } from "./addons/chartOptionsStackedMixin.js";
import Datepicker from "vuejs-datepicker";
import { Switch as cSwitch } from "@coreui/vue";
exporting(Highcharts);

export default {
  mixins: [ chartFunctionsMixin, chartOptionsStackedMixin ],
  components: {
    highcharts: Chart,
    Highcharts,
    Datepicker,
    cSwitch
  },
  props: ["size", "offset", "title", "isCity", "withDate", "withFinancial", "chartType", "city"],
  methods: {
    fetchData() {
      this.loadingData = true;

      let finType = "Fin";
      if (!this.valueQuantity || this.valueQuantity == "false") {
        finType = "Qty";
      }

      let link = null;

      if(this.chartType == "repair") {
        link = "api/hit/charts/repair.php"
      } else if (this.chartType == "historical") {
        if(this.city) {
          link = "api/hit/charts/historicalByProdGroupCity.php"
        } else {
          link = "api/hit/charts/historicalByProdGroup.php"
        }
      }

      let params = {};
       params = {
        date_from: "2020-01-01",
        date_to: this.dateTo,
        type: finType,
        client: this.city
      };

      this.$http.get(link, { params }).then(
          res => {
            let myArray = res.data;
            let xAxis = [];
            var datum = [];

            var fiber = {
              name: "Total",
              data: [],
              color: "rgb(124, 181, 236)"
            };

            for (var type in myArray) {
              datum.push([type, myArray[type]]);
            }

          if (this.chartType == "repair") {
            datum.forEach(obj => {
              var last2 = obj[0].slice(-2);
              if (last2 == "01") {
                xAxis.push("January");
              } if (last2 == "02") {
                xAxis.push("February");
              } if (last2 == "03") {
                xAxis.push("March");
              } if (last2 == "04") {
                xAxis.push("April");
              } if (last2 == "05") {
                xAxis.push("May");
              } if (last2 == "06") {
                xAxis.push("June");
              } if (last2 == "07") {
                xAxis.push("July");
              } if (last2 == "08") {
                xAxis.push("August");
              } if (last2 == "09") {
                xAxis.push("September");
              } if (last2 == "10") {
                xAxis.push("October");
              } if (last2 == "11") {
                xAxis.push("November");
              } if (last2 == "12") {
                xAxis.push("December");
              }

            fiber.data.push(obj[1].Total);
            });

          } else {
            datum.forEach(obj => {
              xAxis.push(obj[0]);
              fiber.data.push(obj[1].Total);
            });
          }

            this.chartOptions.xAxis.categories = xAxis;
            this.chartOptions.series[0] = fiber;
            this.chartOptions.series[0].color = 'rgb(144, 237, 125)';


            if (finType == "Fin") {
              this.chartOptions.tooltip.formatter = function() {
                return (
                  "<b>" +
                  this.x +
                  "</b><br>" +
                  this.series.name +
                  ": $" +
                  this.y.toFixed(2).replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1,")
                );
              };

              this.chartOptions.plotOptions.column.dataLabels.formatter = function() {
                return "$" + this.y.toFixed(2).replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1,");
              };

              this.chartOptions.yAxis.stackLabels.formatter = function() {
                return "Total: " + "$" + this.total.toFixed(2).replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1,");
              };
            } else {
              this.chartOptions.tooltip.formatter = function() {
                return (
                  "<b>" +
                  this.x +
                  "</b><br>" +
                  this.series.name +
                  ": " +
                  this.y +
                  " units"
                );
              };

              this.chartOptions.plotOptions.column.dataLabels.formatter = function() {
                return this.y;
              };

              this.chartOptions.yAxis.stackLabels.formatter = function() {
                return "Total: " + this.total;
              };
            }

            this.loadingData = false;
            setTimeout(() => {
              this.changeHeight();
            });
          },
          err => {
            this.loadingData = false;
            console.log(err);
          }
        );
    },
  },
  mounted() {
    this.fetchData();
  }
};
</script>

<style>
/* IE fix */
#card-chart-01,
#card-chart-02 {
  width: 100% !important;
}
.highcharts-exporting-group {
  display: none !important;
}
/* IE fix */
#card-chart-01,
#card-chart-02 {
  width: 100% !important;
}
.vdp-datepicker__calendar {
  position: absolute !important;
  z-index: 100;
  background: #3a4149 !important;
  width: 300px;
  border: 1px solid #ccc;
}
.form-control:disabled,
.form-control[readonly] {
  background-color: #515b65 !important;
  opacity: 1 !important;
}
</style>
